import AppDataService from "./AppDataService";

export default class TemplateService {
  static async getTemplates(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchValue ? `searchValue=${data.searchValue}` : "",
      data?.status ? `status=${data.status}` : "",
      data?.type ? `type=${data.type}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`admin/template${queryString}`, {
      skipFacilityId: true,
    });
  }

  static async getTemplateById(id) {
    return await AppDataService.get(`admin/template/${id}`);
  }
}
